import gql from 'graphql-tag'

const query = gql`
query listProducts_withEANCode($filter: ProductFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listProducts(filter: $filter, params: $params) {
			items {
				id
				name
				EANCode
				code
				isActive
			}
			hasNextPage
		}
	}
}`

export default query
